<template>
  <div class="mainHolder">
        <div id="sec-one">
            <div class="outer">
                <div class="content">
                    <div class="item">
                        <div id="leftPanel">
                            <TopBar/>

                            <div class="sectionHistoryDetail">
                                <div id="mainMenuSelected">HISTORY</div>
                                <p class="infoOption">You can check here the status, dates and older messages you have sent.</p>
                            </div>
                            <div class="mainManu">
                                <div>
                                    <router-link to="/" class="navbar-brand">
                                        BACK TO MAIN MENU
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="sec-two" >
            <div class="outer">
                <div class="content">
                    <div class="p15">
                        <Logo className="item pt30 smallMainLogo"/>
                    </div>
                    
                    <div class="bg-history">
                        <p class="titleHistory">You can sort  your results by phone number, date, status or sender:</p>
                        
                        <div class="holder_history_sms">
                            <div class="holderSelectSort">
                                    <button  @click="sort('recipient')">
                                        Phone Number
                                    </button>
                                    <button  @click="sort('createdAt')">
                                        Date
                                    </button>
                                    <button  @click="sort('status')">
                                        Status
                                    </button>
                                    <button  @click="sort('createdByName')">
                                        Sender
                                    </button>
                                 </div>
                            <div class="content_history_sms" >
                                
                                <table class="table table-hover table-bordered" id="example">
                                    <thead>
                                        <tr>
                                            <th scope="col" @click="sort('recipient')" class="setOrder down">PHONE NUMBER</th>
                                            <th scope="col" @click="sort('createdAt')" class="setOrder down">DATE SENT</th>
                                            <th class="spaceCol" scope="col" >MESSAGE</th>
                                            <th scope="col" @click="sort('status')" class="setOrder down">STATUS</th>
                                            <th scope="col" @click="sort('createdByName')" class="setOrder down" >SENT BY</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, key) in sortedSMS" :key="key">
                                            <td scope="row" data-label="PHONE NUMBER"><div>{{ item.recipient }}</div></td>
                                            <td data-label="DATE SENT"><div>{{ item.createdAt }}</div></td>
                                            <td class="spaceCol" data-label="MESSAGE" ><div class="myElement"><div>{{ item.content  }}</div></div></td>
                                            <td data-label="STATUS"><div>{{ item.status }}</div></td>
                                            <td data-label="SENT BY"><div>{{ item.createdByName }}</div></td>
                                        </tr>
                                    </tbody>
                                </table>
                               
                            </div>
                            <div class="fa-3x holderLoadingHistory" v-if="loadingPage">
                                    <i class="fas fa-spinner fa-spin"></i>
                            </div>
                            <div class="holderPagination" v-if="pages > 1 && !loadingPage">  
                                
                                <!-- debug: sort={{currentSort}}, dir={{currentSortDir}} -->
                                <nav 
                                    class="pagination"
                                    role="navegation"
                                    aria-label="pagination"
                                >
                                <ul>
                                    <li>
                                        <button 
                                            class="pagination-previous" 
                                            @click.prevent="changePage( page - 1 )"
                                            :disabled="page == 1"
                                        >
                                            Prev
                                        </button>
                                    </li>
                                   
                                        
                                            <li>
                                                <button  class="pagination-link is-current">{{ page }}</button>
                                            </li>
                                       <li>  
                                        <button    
                                            class="pagination-next" 
                                            @click.prevent="changePage( page + 1 )"
                                            :disabled="page == pages"
                                        >
                                            Next
                                        </button>
                                       </li>
                                    </ul>
                                </nav>    
                            </div>
                        </div>
                        <router-link   v-bind:to="{ name: 'SendMessage' }" class="btnSendMsg">
                            SEND NEW MESSAGE
                        </router-link>
                         <br>
                         <br>
                         <br>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TopBar from '../components/TopBar.vue'
import MainMenu from '../components/MainMenu.vue'
import Logo from '../components/Logo'
import axios from "axios";

//Datatable Modules
import $ from 'jquery'; 

export default {
    props:['templates_data'],
    components: {
        TopBar,
        MainMenu,
        Logo
    },
    data() {
        return {
            data_messages:[],
            loadingPage: false,
            page: 1,
            pages: "",

            currentSort:'createdAt',
            currentSortDir:'desc',

            
        };
    },
    computed:{
        sortedSMS:function() {
            return this.data_messages.sort((a,b) => {
                let modifier = 1;
                if(this.currentSortDir === 'desc') modifier = -1;
                if(a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
                if(a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
                return 0;
            });
        }
    },
    mounted(){

    },
    created(){
        this.getMsgBox()
    },  
    methods:{
        async getMsgBox(){
            const self = this;
            self.loadingPage = true;

            axios({
                method: "get",
                url: `https://www.miltoolsms.ca/api/v1/messages?page=${this.page}`,
                responseType: "json",
                //data: params,
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: "Bearer " + localStorage.getItem('token')//dataUser.data.jwt
                }
            })
            .then(function(response) {
                if (response.data) {

                    self.pages = (response.data.meta.pagination.totalPages) //Get Total pages

                    let arrData = [];
                    response.data.data.forEach(element => {
                        //console.log(element.id)
                        arrData.push({
                            id:element.id, 
                            recipient: self.formatMaskPhoneNumber(element.recipient), 
                            content: element.content,
                            status:element.status, 
                            createdByName: element.createdBy.name,
                            createdByEmail: element.createdBy.email,
                            createdAt: self.formatDate(element.createdAt)
                        })
                    });
                    self.data_messages = arrData

                    self.loadingPage = false
                    
                    $(document).ready(function(){

                    });
                    
                }else{
                    self.callToast(`There was an error`, 'warning')
                }

                self.loadingPage = false
            })
            .catch(error => (self.callToast(`There was an error: ${error}`, 'warning'), (self.loadingPage = false)));   
        },

        callToast(message, status){
            this.$toast.show(message, {
                type: status,
                position: 'top-right'
                // all of other options may go here
            });
        },

        changePage(page){
            
            this.page = (page <= 0 || page > this.pages)? this.page : page
            
            this.getMsgBox()
        },

        sort(s) {
          
            //if s == current sort, reverse
            if(s === this.currentSort) {
                this.currentSortDir = this.currentSortDir==='asc'?'desc':'asc';
            }
            this.currentSort = s;
        },

        formatDate(d)
        {
            //let d = '2007-04-06T00:00Z';
            return d.substring(5,7)+' / '+d.substring(8,10)+' / '+d.substring(0,4);
            // outputs 04/06/2007
        },

        formatMaskPhoneNumber(number){
            //return number;    
            //Filter only numbers from the input
            let cleaned = ('' + number).replace(/\D/g, '');
            
            //Check if the input is of correct length
            let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

            if (match) {
                return '' + match[1] + ' ' + match[2] + ' ' + match[3]
            };

            return number

        }
    }
}
</script>

<style>

</style>